<template>

	<div id="content" class="content login">

		<div class="container">
			<!-- 페이지 타이틀 -->
			<div class="page-title">
				<h2 class="tit_page">회원가입</h2>
			</div>
			<form @submit.prevent="doLogin">

				<div class="login_button">
					<router-link to="/member/joinForm" class="btn btn_login">이메일로 회원가입</router-link>
<!--					<a href="/member/joinForm" class="btn btn_login">이메일로 회원가입</a>-->
				</div>
				<div class="login_sns" v-show="subDomain === 'www'">
					<template v-if="isIOS">
						<a href="#" class="btn login_naver" @click="naverLoginOnIOS"><img src="/ssflex_cs1/assets/img/common/ico/ico_naver.svg" alt="">네이버로 로그인<a class="hide-login-image"></a></a>
						<a class="hide-login-image" id="naver_id_login" style="display: none"></a>
					</template>

					<!-- NAVER LOGIN ON ANDROID/WINDOW -->
					<template v-else>
						<a href="#" class="btn login_naver" @click="naverLogin"><img src="/ssflex_cs1/assets/img/common/ico/ico_naver.svg" alt="">네이버로 로그인<a class="hide-login-image" id="naver_id_login"></a></a>
					</template>
					<!--						<a href="#" class="btn login_naver"><img src="/ssflex_cs1/assets/img/common/ico/ico_naver.svg" @click="naverLoginOnIOS" alt=""><span>네이버로 로그인</span></a>-->
					<!--						<a class="hide-login-image" id="naver_id_login" style="display: none"></a>-->
					<a href="#" class="btn login_kakao" @click="kakaoLogin"><img src="/ssflex_cs1/assets/img/common/ico/ico_kakao.svg" alt=""><span>카카오로 로그인</span></a>
					<a href="#" class="btn login_apple" @click="doAppleLogin"><img src="/ssflex_cs1/assets/img/common/ico/ico_apple.svg" alt=""><span>애플로 로그인</span></a>
				</div>
			</form>
			<input id="callBackIOSApple" type="text" v-model="callBackIOSDataApple" v-show="false"/>
		</div>


	</div>

</template>


<!--<script type="application/javascript" src="https://developers.kakao.com/sdk/js/kakao.js"></script>-->
<!--<script type="application/javascript" src="https://static.nid.naver.com/js/naverLogin_implicit-1.0.3.js" charset="utf-8"></script>-->
<script>

// import Kakao from "https://developers.kakao.com/sdk/js/kakao.js"

// import("https://developers.kakao.com/sdk/js/kakao.js")
// import("https://static.nid.naver.com/js/naverLogin_implicit-1.0.3.js")

import webUtils from "@/commons/utils/web.utils";

export default {
	name: "joinStart",
	data() {

		return {

			LOCAL: location.hostname,

			userid: "",
			passwd: "",
			deviceToken: "",
			isKeepSession: false,
			isIOS: false,
			callBackIOSDataApple: "",
			subDomain: "",
			naverCallVal: "",

			isShowShopping: true,
			isShowSnsLogin: true,
		}
	},
	created() {
		this.$loadScript("https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js").then(() => {

			$('#appleid-signin').hide()

			window.AppleID.auth.init({
				clientId: "com.ssflex.app.web",
				scope: "name email",
				redirectURI: this.APIs.APPLE_LOGIN_RETURN,
				state: "origin:web",
				usePopup: true,
			});

			document.addEventListener('AppleIDSignInOnSuccess', (data) => {
				//console.log(data)
				this.callBackAppleLogin(data)
			});

			document.addEventListener('AppleIDSignInOnFailure', (e) => {
				if (webUtils.getParameter("subDomain") !== "" && webUtils.getSubdomainWithURLString(location.origin) !== "www") {
					location.href = location.href.replace(webUtils.getSubdomainWithURLString(location.origin), webUtils.getParameter("subDomain")).replace(/[&;]?subDomain=[^&;]+/, "")
				}
			});

			if (webUtils.getParameter("subDomain") !== "") {
				document.querySelectorAll('body').forEach(e => e.style.display = 'none')
				document.querySelector('#appleid-signin').click()
			}

		})

		// get connected iOS or MacOS
		if (((navigator.userAgent).indexOf("iPad")) !== -1 || ((navigator.userAgent).indexOf("iPhone")) !== -1 || ((navigator.userAgent).indexOf("iPod")) !== -1) {
			this.isIOS = true;
		}

		this.subDomain = webUtils.getSubdomain();

		if ( this.isLogin() ) {
			this.swalUtils.fire("현재 로그인 되어 있습니다.", "메인으로 이동합니다.", "info")
				.then(() => {
					location.href = "/"
				})
		}
	},
	mounted() {

		this.$loadScript("https://developers.kakao.com/sdk/js/kakao.js")
			.then(() => {
				this.kakaoInit();
			})

		this.$loadScript("https://static.nid.naver.com/js/naverLogin_implicit-1.0.3.js")
			.then(() => {
				this.naverInit();
				$('#naver_id_login_anchor').hide()
			})

		// this.appDeviceToken("#deviceToken")
		// this.getAndroidDeviceToken();
		// this.getIOSDeviceToken();

		this.getCompanyInfo();

	},
	watch: {},
	updated() {
	},
	methods: {

		doLogin(e) {

			e.preventDefault()


			this.doLoginProc( this.userid, this.passwd, () => {

				this.setSessionKeep( this.isKeepSession );
				this.goWithCoCode(this)
				// if ( !this.stringUtils.isEmpty( this.$route.query.referrer ) ) {
				// 	console.log( this.$route.query.referrer )
				// 	location.href = this.$route.query.referrer
				// } else {
				// 	location.href = "/"
				// }
				return
			});

		},


		goReferrer () {
			if ( !this.stringUtils.isEmpty( this.$route.query.referrer ) ) {
				console.log( this.$route.query.referrer )
				location.href = this.$route.query.referrer
			} else {
				location.href = "/"
			}
		},



		async getCompanyInfo () {

			const self = this

			self.coInfoVO = await self.getCoInfoVO()
			// 아이폰이 경우 사이트 설정 따라가게 설정
			if ( self.appDevice() === "IOS" ) {
				self.isShowShopping = self.coInfoVO.isIosShop
				self.isShowSnsLogin = self.coInfoVO.isIosSns
			}

		},


		kakaoInit() {
			const self = this
			window.Kakao.init(this.APIs.KAKAO_LOGIN_KEY);
			const ksksoInitResult = window.Kakao.isInitialized();
			console.log("ksksoInitResult", ksksoInitResult)
			if (!ksksoInitResult) {
				self.swalUtils.fire(ksksoInitResult.name, ksksoInitResult.message, "error")
			}
		},

		kakaoLogin (e) {

			if (this.isIOS === true) {
				this.kakaoLoginOnIOS();
				return;
			}

			const self = this
			console.log(e)

			/**
			 * 카카오 로그인 팝업
			 */
			if ( !window.Kakao.isInitialized() ) {
				this.kakaoInit();
			}

			window.Kakao.Auth.login({
				success: function(authObj) {
					console.log( authObj )

					window.Kakao.API.request({
						url: '/v2/user/me',
						success: function(response) {
							console.log(response);

							// DONE : SNS 정보로 로그인 및 없을 경우 저장 후 가입폼으로
							self.axiosCaller.get(self, self.APIs.SESSION + "/doSnsLogin", {
								snsService: "kakao",
								snsId: response.id,
								deviceToken: ( self.webUtils.isDom( '#deviceToken' ) ) ? document.querySelector('#deviceToken').value : "",
							}, async (res) => {
								const result = res.data;
								if (result.status === "ok") {
									if (await self.setSessionProc(result.coAccountVO)) {
										self.setSessionKeep( self.isKeepSession );
										self.goWithCoCode(self)
									}
								} else {
									self.swalUtils.gritter("Error", result.msg, "info", 1500)
								}

							})

						},
						fail: function(error) {
							console.log(error);
							self.swalUtils.fire( error.name, error.message, "error" )
						}
					});

				},
				fail: function(error) {
					console.log( error )
					self.swalUtils.fire( error.name, error.message, "error" )
				},
			})
		},



		naverInit () {

			console.log(this.APIs.FRONT_URL +  "/member/sns/naverReturn");
			console.log(this.APIs.NAVER_LOGIN_KEY);
			console.log(this.APIs.NAVER_LOGIN_RETURN);

			if (this.isIOS === true) {
				this.naverCallVal = new window.naver_id_login(this.APIs.NAVER_LOGIN_KEY, this.APIs.NAVER_IOS_LOGIN_RETURN);
			} else {
				this.naverCallVal = new window.naver_id_login(this.APIs.NAVER_LOGIN_KEY, this.APIs.NAVER_LOGIN_RETURN);
			}
			// var naver_id_login = new window.naver_id_login("qFDEQxXzXziHz8pT4Y69", "https://localhost:8081/member/sns/naverReturn");
			var state = this.naverCallVal.getUniqState();
			this.naverCallVal.setButton("white", 3, 40);
			// 동적으로 현재 origin 사용
			this.naverCallVal.setDomain(location.origin + "/");
			// naver_id_login.setDomain("https://ssflex.co.kr");
			this.naverCallVal.setState(state);
			this.naverCallVal.setPopup();
			this.naverCallVal.init_naver_id_login();

			console.log('naver_id_login', this.naverCallVal)

		},

		naverLogin () {
			$('#naver_id_login_anchor').click()
		},

		doAppleLogin() {
			if (webUtils.getSubdomainWithURLString(location.origin) !== 'www') {
				location.href = location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), "www") + location.pathname + (location.search === "" ? "?subDomain=" : location.search + "&subDomain=") + webUtils.getSubdomainWithURLString(location.origin)
			} else {
				document.querySelector('#appleid-signin').click()
			}
			// window.open(location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), "www") + '/member/sns/apple/' + webUtils.getSubdomainWithURLString(location.origin), "apple")
			// $('#appleid-signin').click();
		},

		callBackAppleLogin(_result) {

			// "eyJraWQiOiI4NkQ4OEtmIiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJodHRwczovL2FwcGxlaWQuYXBwbGUuY29tIiwiYXVkIjoiY29tLnNzZmxleC5hcHAud2ViIiwiZXhwIjoxNjM4MzIxMTIwLCJpYXQiOjE2MzgyMzQ3MjAsInN1YiI6IjAwMDA1Mi42ZjdhODIwODU1MWM0ODU3YmRlZTljNDA2OWMzOWExOS4wMDMzIiwiY19oYXNoIjoiMVBUX3A5Q3BYYWVSQ29jV0RKUkVwQSIsImVtYWlsIjoia2hhbmUwOTA3QGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjoidHJ1ZSIsImF1dGhfdGltZSI6MTYzODIzNDcyMCwibm9uY2Vfc3VwcG9ydGVkIjp0cnVlfQ.euASmIA1XVuXQ4Fxq_z7UjzZ4U7wEW0kMb4ZM4kQKzO9DEI-_0khX1vJuJPYGADhW-emoDr7oIdRPWeKAqBxAsxewZQTHeT1Y9-S48pGF-GYJwbeUWEOD_7QXSp0Qwd8IPu2jOVTnkbehbPSNOsre7FmPPi7_9_a2Ej1Zki-uHXiS6c7wflkIc4MmmTfMxZPazzC-c_UmVZBlux5SztgvLYJ1g3nDaqZ9yuALYkMbSPIxrnC1fiKhMnHOJLtMHPIDIxyZbWG5V23H_YPLuJpkKUSW0rT_hIwNKR_Ev3Ie09eABrWe_gCGZjaOKGDIn-DRbug1pr7yvBIN1iOf6PTdg"
			const response = JSON.parse(atob((_result.detail.authorization.id_token).split('.')[1]));
			const uid = response.sub;
			let name;
			let email;

			if (_result.detail.user != null) {
				name = _result.detail.user.name.lastName + _result.detail.user.name.firstName;
				email = _result.detail.user.email;
			}

			if (response.email_verified === "true") {
				email = response.email;
			}

			console.log(response)
			console.log(email)
			console.log(name)

			console.log("get IOS Data")
			const self = this
			self.axiosCaller.get(self, self.APIs.SNS_APPLE + "/doSnsLogin", {
				snsService: "apple",
				snsId: uid,
				email: email,
				name: name,
				deviceToken: (self.webUtils.isDom('#deviceToken')) ? document.querySelector('#deviceToken').value : "",
				LOGIN_DOMAIN: webUtils.getParameter("subDomain") !== '' ? webUtils.getParameter("subDomain") : null,
				coCode: webUtils.getParameter("subDomain") !== '' ? webUtils.getParameter("subDomain") : null
			}, async (res) => {
				const result = res.data;
				console.log(result)

				if ( result.status === "integrated_login" ) {
					self.swalUtils.fire("계정 통합", result.msg, "info")
						.then(async swalResult => {
							console.log(swalResult)
							if (swalResult.isConfirmed || swalResult.dismiss) {
								if (await self.setSessionProc(result.coAccountVO)) {
									self.setSessionKeep(self.isKeepSession);
									self.goWithCoCode(self)
								}
							}
						});
					return
				}

				if (result.status === "login") {
					if (await self.setSessionProc(result.coAccountVO)) {
						self.setSessionKeep(self.isKeepSession);
						self.goWithCoCode(self)
					}
				} else {
					self.swalUtils.gritter("Error", result.msg, "info", 1500, () => {
						if (webUtils.getParameter("subDomain") !== "") {
							location.href = location.href.replace(webUtils.getSubdomainWithURLString(location.origin), webUtils.getParameter("subDomain")).replace(/[&;]?subDomain=[^&;]+/, "")
						}
					})
				}

			})
			console.log("callback parameter: " + uid);
		},

		kakaoLoginOnIOS() {

			var self = this;
			const url = 'https://kauth.kakao.com/oauth/authorize?'
				+ 'client_id=' + self.APIs.KAKAO_REST_API_LOGIN_KEY + '&'
				+ 'redirect_uri=' + self.APIs.KAKAO_IOS_LOGIN_RETURN + '&'
				+ 'response_type=' + 'code';

			location.href = url

		},

		naverLoginOnIOS() {

			console.log(this.naverCallVal)

			var self = this;
			const url = 'https://nid.naver.com/oauth2.0/authorize?'
				+ 'client_id=' + self.naverCallVal.client_id + '&'
				+ 'redirect_uri=' + self.naverCallVal.redirect_uri + '&'
				+ 'response_type=' + 'code' + '&'
				+ 'state=' + self.naverCallVal.state;

			// location.href = url

		}

	},
}
</script>

<style scoped>
@media (max-width: 767px){
	.login .link-area a {
		font-size: 15px;
		line-height: 3.6;
	}
}
.hide-login-image {
	position: relative;
	top: -56px;
	left: -36px;
	width: 0;
	height: 0;
	opacity: 0;
}
.login .sns-account .btn-apple {
	background-color: #1c1c1e;
	background-image: url(/ssflex/assets/img/common/ico_apple.png);
	color: #fff;
}
</style>
